(() => {
    const header = document.querySelector('.header');

    const followScroll = () => {
        header.style.transform = `translateY(${window.scrollY / 10}px)`;

        requestAnimationFrame(followScroll);
    };

    // requestAnimationFrame(followScroll);
})();

(() => {
    const path = window.location.pathname;
    const links = document.querySelectorAll(`a[href="${path}"]`);

    [...links].forEach((link) => {
        link.classList.add('is-active');
    });
})();



// WEBPACK FOOTER //
// ./resources/sitewide.js